"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.onRouteUpdate = void 0;

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var onRouteUpdate = function onRouteUpdate(_ref, _ref2) {
  var location = _ref.location;
  var _ref2$isCookieConsent = _ref2.isCookieConsentEnabled,
      isCookieConsentEnabled = _ref2$isCookieConsent === void 0 ? true : _ref2$isCookieConsent,
      _ref2$controlCookieNa = _ref2.controlCookieName,
      controlCookieName = _ref2$controlCookieNa === void 0 ? 'cookie_control_consent' : _ref2$controlCookieNa;

  if (process.env.NODE_ENV === "production" && typeof window._etracker !== "undefined") {
    if (isCookieConsentEnabled) {
      if (_jsCookie.default.get(controlCookieName) === "true") {
        window._etracker.enableCookies(location.host);

        window._etracker.enableTracking(location.host);
      } else {
        window._etracker.disableTracking(location.host);

        window._etracker.disableCookies(location.host);
      }
    }
  }
};

exports.onRouteUpdate = onRouteUpdate;